import { FC } from 'react';
import { CustomButton } from 'components';
import { ButtonType } from 'components/custom-button/CustomButton';
import RelatedEstimateCard from 'containers/estimates/components/RelatedEstimateCard';
import RelatedJobCard from 'containers/jobs/components/RelatedJobCard';
import { RelatedJob } from 'containers/estimates/estimates.model';

interface InvoiceRelatedDocumentsSectionProps {
  relatedJobs: any[] | null;
  relatedEstimates: any[] | null;
  onJobClick: (jobId: string) => void;
  onRemoveJob: (jobId: string) => void;
  onAddJobFromInvoice: () => void;
  onEstimateClick: (estimateId: string) => void;
  onRemoveEstimate: (estimateId: string) => void;
}

const InvoiceRelatedDocumentsSection: FC<InvoiceRelatedDocumentsSectionProps> = ({
  relatedJobs,
  relatedEstimates,
  onJobClick,
  onRemoveJob,
  onAddJobFromInvoice,
  onEstimateClick,
  onRemoveEstimate
}) => {
  return (
    <div className="w-full rounded-md bg-white shadow-section">
      <div className="px-5 py-3 text-17px font-bold text-headingGray">Related documents</div>
      <div className="px-5 pt-2 pb-4">
        {/* Jobs Section */}
        <div className="mb-4">
          <div className="pb-3 text-sbase font-bold text-primaryText">Job</div>
          {relatedJobs?.length > 0 ? (
            <>
              {relatedJobs.map(job => {
                const relatedJob = {
                  ...job,
                  isScheduled: Boolean(job.scheduledFrom && job.scheduledTo),
                  profilePicture: job.profilePicture || '',
                  merchantName: job.merchantName || ''
                };

                return (
                  <div key={job.jobId} className="w-full">
                    <RelatedJobCard
                      job={relatedJob as unknown as RelatedJob}
                      onJobClick={onJobClick}
                      onRemoveJob={onRemoveJob}
                      className="rounded py-3 px-4"
                    />
                  </div>
                );
              })}
            </>
          ) : (
            <CustomButton
              id="add-job-from-invoice"
              type={ButtonType.SECONDARY}
              className="mb-4 h-10 w-full border-gray-1"
              onClick={onAddJobFromInvoice}>
              <span className="text-xl">+ </span>
              {'  '}Add job
            </CustomButton>
          )}
        </div>

        {/* Estimates Section */}
        {relatedEstimates && relatedEstimates.length > 0 && (
          <div className="mb-4">
            <div className="pb-3 text-sbase font-bold text-primaryText">Estimate</div>
            {relatedEstimates.map(estimate => (
              <div key={estimate.id}>
                <RelatedEstimateCard
                  estimate={estimate}
                  onEstimateClick={onEstimateClick}
                  onRemoveEstimate={onRemoveEstimate}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default InvoiceRelatedDocumentsSection;
